<script lang="ts">
export default {
    name: 'ProductListPanelSearch',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    value?: string;
}>();

const emit = defineEmits<{
    (e: 'input', value?: string): void;
}>();

const model = computed({
    get: () => props.value,
    set: value => emit('input', value),
});

function keydown(e: KeyboardEvent) {
    e.stopPropagation();
}
</script>

<template>
    <base-input
        v-model="model"
        class="flex-1"
        wrapper-class="border-transparent bg-science-blue-900/5 *:placeholder:text-gray-400"
        type="info"
        placeholder="Start typing to find..."
        clearable
        @keydown="keydown"
    >
        <template #prefix>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4 text-gray-400">
                <path
                    fill-rule="evenodd"
                    d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                    clip-rule="evenodd"
                />
            </svg>
        </template>
    </base-input>
</template>
